const waitlistStyle = {
  snackbar: {
    bottom: "10%"
  }
};

export default waitlistStyle;